import React from 'react';
import { useNavigate } from 'react-router-dom';
import PublicNavBar from './PublicNavBar';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-sand-100 to-sand-200">
      <PublicNavBar />
      <div className="flex items-center justify-center py-20 px-4">
        <div className="text-center max-w-lg">
          <h1 className="text-8xl md:text-9xl font-bold text-coral-500 drop-shadow-[4px_4px_0_rgba(0,0,0,1)] mb-4">
            404
          </h1>
          <h2 className="text-2xl md:text-3xl font-bold text-ink-800 mb-4">
            Page Not Found
          </h2>
          <p className="text-ink-600 text-lg mb-8">
            Looks like this page took the day off. Let's get you back on track.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => navigate('/')}
              className="bg-coral-300 text-white px-8 py-3 rounded-lg font-semibold hover:bg-coral-500 transition duration-200"
            >
              Back to Home
            </button>
            <button
              onClick={() => navigate('/dashboard')}
              className="bg-white border-4 border-ink-900 text-ink-800 px-8 py-3 rounded-lg font-semibold hover:bg-sand-50 transition duration-200"
            >
              Go to Dashboard
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;